import moment, { type Moment } from 'moment';

import type { VisitorAppointmentRegistration } from '@/types/database/visitorAppointmentRegistration';

type FilterVisitorAppointmentListParams = {
  visitorAppointmentArr: VisitorAppointmentRegistration[];
  searchVisitorName: string;
  searchHouseholdNumber: string;
  dateStart: Moment;
  dateEnd: Moment;
};

export const filterVisitorAppointmentList = ({
  visitorAppointmentArr,
  searchVisitorName,
  searchHouseholdNumber,
  dateStart,
  dateEnd,
}: FilterVisitorAppointmentListParams) => {
  let filteredVisitorAppointments = visitorAppointmentArr;
  if (searchVisitorName) {
    filteredVisitorAppointments = filteredVisitorAppointments.filter(
      (visitorAppointment) => {
        return visitorAppointment.visitorsName.includes(searchVisitorName);
      }
    );
  }

  if (searchHouseholdNumber) {
    filteredVisitorAppointments = filteredVisitorAppointments.filter(
      (visitorAppointment) => {
        return visitorAppointment.householdNumber === searchHouseholdNumber;
      }
    );
  }

  if (dateStart && dateEnd) {
    filteredVisitorAppointments = filteredVisitorAppointments.filter(
      (visitorAppointment) => {
        const { admissionTime } = visitorAppointment;

        const isBetween = moment(admissionTime).isBetween(
          dateStart,
          dateEnd,
          'date',
          '[]'
        );

        return isBetween;
      }
    );
  }

  return filteredVisitorAppointments;
};
